var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star"},_vm._l((_vm.starList),function(i,index){return _c('span',{key:index,staticClass:"star-item",class:i,on:{"click":function($event){return _vm.rateNum(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }